import React,{useState,useEffect,useRef, useContext} from 'react';
import { Container, Col, Row, Form } from 'react-bootstrap';
import { AuthContext } from '../../auth/AuthContext';
import { TablaGrupos, TablaPromotorias } from '../../Components/Components';
import '../../pages/Dashboard/dashboard.css';
import {
  BrowserRouter as Router,
  Redirect,
  useHistory,
} from "react-router-dom";


export const Grupos = ({state,updateState}) => {
  let history = useHistory();
  const { usuario } = useContext(AuthContext);
  const ref = useRef(null);
  const currentYear = new Date().getFullYear();
  const {openMenu, data, loadingData} = state;
  const [viewTab,setViewTab] = useState(0);
  const [isSticky, setSticky] = useState(false);
  const [yearG, setYearG] = useState(currentYear);
  const [dataGrupos,setDataGrupos] = useState([]);
  const [dataPromotorias,setDataPromotorias] = useState([]);
  const [loadGrupos,setLoadGrupos] = useState(true);
  const [loadPromotorias,setLoadPromotorias] = useState(true);

  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 

  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])

  useEffect(() => {
    getAvancesAllGrupos()
    getAvancesAllPromotorias()
  },[yearG])

  const { nombre,tipo } = usuario;

  // if(tipo=='3'){
  //   history.replace("/agentes");
  //   return false;
  // }

  return (
    <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">

        <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{ borderBottom: '1px solid #ccc' }}>
          <Row>
            <Col className="mb-2" xs={12} md={3}>
              <h1 className="ws_title_header">Grupos</h1>
            </Col>
          </Row>
        </Container>

        <Container fluid className="mt-5">
          <Row>
            <TablaGrupos 
            state={state} 
            updateState={updateState} 
            data={dataGrupos} 
            load={loadGrupos} 
            setLoad={setLoadGrupos}
            year={yearG} 
            setYear={setYearG} />
          </Row>
          <Row>
            <TablaPromotorias 
            state={state} 
            updateState={updateState} 
            data={dataPromotorias} 
            load={loadPromotorias} 
            setLoad={setLoadPromotorias}
            year={yearG} 
            setYear={setYearG}
            />
          </Row>
        </Container>
      </div>
    </div>
  )

  function getAvancesAllGrupos() {
    setLoadGrupos(true)
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvancesAllGrupos`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({id_login: usuario.id_usuario, year: yearG })
    })
      .then(res => res.json())
      .then((res) => {
        setLoadGrupos(false)
        setDataGrupos(res)
      })
  }

  function getAvancesAllPromotorias() {
    setLoadPromotorias(true)
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvancesAllPromotorias`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({id_login: usuario.id_usuario, year: yearG })
    })
      .then(res => res.json())
      .then((res) => {
        setLoadPromotorias(false)
        setDataPromotorias(res)
      })
  }
}